/**
 * Portal Manta · agAluciGuardURL
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { aluciAuditarTexto } from './aluciAuditarTexto.jsx';

function agAluciGuardURL(ctx, prev){
  if (!ctx || !ctx.texto) return {status:'sem-texto'};
  const env = aluciAuditarTexto(ctx.texto, ctx.opcoes);
  const achados = env.achados.filter(a => a.tipo === 'AL-02_url' || a.tipo === 'AL-02_doi');
  return {sub:'Auditor URL/DOI', status:achados.length===0?'ok':'atencao', msg:achados.length+' aluci AL-02 (URL/DOI)', achados};
}

export { agAluciGuardURL };
export default agAluciGuardURL;
